export default __webpack_public_path__ + "static/media/empty-draft.c1e6430e.svg";